module.exports = __webpack_public_path__ + "img/200528_ERG-19-2829_Broschuere_SBU_210x297_RZ-2.f5655ea1.jpg";